import { useParams, useNavigate } from "react-router-dom";
import { ActivationForm } from "../components/subject/ActivationForm";

export default function SubjectActivation() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  if (!code) {
    return (
      <main className="min-h-screen flex items-center justify-center px-6">
        <p className="text-ink-500">No interview code in the link.</p>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-md w-full space-y-10">
        <header className="text-center space-y-3">
          <h1 className="font-display text-4xl tracking-tight text-ink-900">
            A few questions for you.
          </h1>
          <p className="text-ink-700 leading-relaxed">
            Someone invited you to a brief, voice-or-text conversation. There are no wrong answers.
          </p>
        </header>
        <ActivationForm code={code} onActivated={() => navigate(`/i/${code}/session`)} />
        <p className="text-center text-xs text-ink-300">
          Your answers go only to the person who invited you.
        </p>
      </div>
    </main>
  );
}
